import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueBootstrap from 'bootstrap-vue';
import VueTheMask from 'vue-the-mask';
import UUID from 'vue-uuid';
import VueMoment from 'vue-moment';
import VueSweetalert2 from 'vue-sweetalert2';
import VueMarkdown from 'vue-markdown';
import _ from 'lodash';
import GoTop from '@inotom/vue-go-top';
import VModal from 'vue-js-modal';
import VCalendar from 'v-calendar';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import loading from 'vuejs-loading-screen';

import { store } from './store';
import { router } from './routes';
import App from './App';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlus,
  faMinusCircle,
  faExclamationTriangle,
  faTrash,
  faAngleLeft,
  faAngleRight,
  faSpinner,
  faPen,
  faTimes,
  faMinus,
  faShoppingCart,
  faIdCard,
  faEye,
  faEyeSlash
} from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import money from 'v-money';

import VuePageTransition from 'vue-page-transition';

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css';

import { Settings } from 'luxon';
import SweetModal from 'sweet-modal-vue/src/plugin.js';

import VueLightbox from 'vue-lightbox';

import moment from 'moment-timezone';
import 'moment/locale/fr-ca';
moment.locale('fr-ca');

// Axios config
axios.defaults.baseURL = process.env.VUE_APP_BACKEND;

library.add(faPlus, faMinusCircle, faExclamationTriangle, faTrash, faAngleLeft, faAngleRight, faSpinner, faPen, faTimes, faMinus, faShoppingCart, faIdCard);
library.add(faFacebook, faTwitter, faEye, faEyeSlash);

// Inject stripe
// eslint-disable-next-line no-undef
Vue.prototype.$stripe = Stripe(process.env.VUE_APP_STRIPE_KEY, {
  locale: 'fr'
});

// register directive v-money and component <money>
Vue.use(money, {
  precision: 2,
  decimal: ',',
  thousands: ' ',
  prefix: '',
  suffix: ' $'
});
Vue.use(VeeValidate);
Vue.use(VueBootstrap);
Vue.use(VueTheMask);
// Vue.use(VueLodash, { name: '_' });
Object.defineProperty(Vue.prototype, '_', { value: _ });
Vue.use(UUID);
Vue.use(VueMoment);
Vue.use(VueSweetalert2, {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
});
Vue.use(GoTop);
Vue.use(SweetModal);
Vue.use(VuePageTransition);
Vue.use(VModal, {
  dynamic: true,
  dialog: true
});
Vue.use(VCalendar);
Settings.defaultLocale = 'fr';

Vue.use(Vuelidate);
Vue.use(loading, {
  bg: 'rgba(47,47,47,0.68)',
  slot: `
    <div class="px-5 py-3 bg-gray-800 rounded">
      <h3 class="text-3xl text-white"><i class="fas fa-spinner fa-spin"></i> Chargement...</h3>
    </div>
  `
});

Vue.component('vue-markdown', VueMarkdown);
Vue.component('lightbox', VueLightbox);
Vue.component('font-awesome-icon', FontAwesomeIcon);

require('./filters');

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
